export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_print_export') || '打印导出',
    icon: 'el-icon-printer',
    menuType: 'export',
    divided: true,
    allow: 'E',
  },
  {
    text: that.$l('btn_tips_email') || '邮件发送',
    icon: 'el-icon-message',
    menuType: 'sendEmail',
    divided: true,
    allow: 'S',
    show: ({ orderStatus }) => orderStatus === 11,
  },
  {
    text: that.$l('btn_tips_confirm') || '订单确认',
    icon: 'el-icon-circle-check',
    menuType: 'confirm',
    divided: true,
    allow: 'F',
    show: ({ orderStatus }) => orderStatus === 10,
  },
  {
    text: that.$l('btn_tips_upload_file') || '上传附件',
    icon: 'el-icon-upload',
    menuType: 'uploadFile',
    divided: true,
    allow: 'U',
  },
]
